import { SearchBox, Toolbar, ToolbarButton } from "@fluentui/react-components";
import {
  ArrowClockwiseRegular,
  CalculatorRegular,
  DocumentPersonRegular,
  SettingsRegular,
  ChatHelpRegular,
} from "@fluentui/react-icons";
import { ColumnOptionsButton } from "@greco/components";
import { useState } from "react";
import { areAnyColumnsFilteredState } from "store/OffersPageStore";
import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "library/constants";
import { useLocation } from "react-router-dom";

interface Props {
  columnOptions?: JSX.Element;
  displaySearch?: boolean;
  displayReload?: boolean;
}

export const Navigation = ({
  columnOptions,
  displaySearch = false,
  displayReload = false,
}: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isHome = location.pathname === ROUTES.HOME;
  const isOffer = location.pathname === ROUTES.OFFER;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        padding: "0 16px",
        boxSizing: "border-box",
        borderBottom: "1px solid #EDEBEF",
      }}
    >
      {/* Left side of the toolbar */}
      <Toolbar
        size="large"
        aria-label="Toolbar with buttons"
        style={{ flex: 1 }}
      >
        <ToolbarButton
          aria-label="Offers"
          appearance={isHome ? "primary" : "subtle"}
          icon={<DocumentPersonRegular />}
          onClick={() => {
            navigate(ROUTES.HOME, { replace: true });
          }}
        />
        <ToolbarButton
          aria-label="Calculator"
          appearance={isOffer ? "primary" : "subtle"}
          icon={<CalculatorRegular />}
          onClick={() => {
            navigate(ROUTES.ITEM_PAGE, { replace: true });
          }}
        />
        {displaySearch && (
          <SearchBox
            placeholder="Search offers"
            style={{ flex: 1, margin: "0 16px" }}
          />
        )}
        {displayReload && (
          <ToolbarButton
            aria-label="Reload"
            appearance="subtle"
            icon={<ArrowClockwiseRegular />}
          />
        )}
      </Toolbar>

      {/* Right side of the toolbar */}
      <div style={{ display: "flex", gap: "8px" }}>
        {columnOptions}
        <ToolbarButton
          aria-label="Help"
          appearance="subtle"
          icon={<ChatHelpRegular />}
        />
      </div>
    </div>
  );
};
